import type { ExtractPropTypes, UnwrapNestedRefs } from "vue";
import { reactive } from "vue";
import { props } from "quick-vue-components/index";
import { getCurrentLocale } from "@user-center/utils/i18n";
import { isSassmallResponseSuccess } from "~/sassmall/api/client";
import { pageSassmallShopAnnouncements } from "~/sassmall/api/notifications";
import { getSassmallToken } from "~/sassmall/storage";
import {
  filterActiveNotices,
  isNoticeHiddenByScope,
  localizeNotices,
} from "./noticeUtils";

export interface NoticeBarType {
  noticeBarState: UnwrapNestedRefs<NoticeBarStateType>;
  getListAction():Promise<void>
}
export type NoticeBarStateType = {
  noticeDataVisible: boolean;

  viewNoticeIdx: number;
  findNoticeDatas: any[];
};
export const NoticeBarProps = props.buildProps({
  isShowBar: {
    type: Boolean,
    default: true,
  },
  autoPopup: {
    type: Boolean,
    default: true,
  },
  pageSize: {
    type: Number,
    default: 99,
  },
  storageScope: {
    type: String,
    default: "default",
  },
});
export type NoticeBarPropsType = ExtractPropTypes<typeof NoticeBarProps>;

function normalizeAnnouncementList(responseData: any): any[] {
  const list = responseData?.records
    || responseData?.dataList
    || responseData?.list
    || responseData?.rows
    || [];

  if (!Array.isArray(list)) {
    return [];
  }

  return list.map((item: any) => ({
    ...item,
    content: item?.siteContent || item?.content || "",
    status: item?.status === undefined || item?.status === null ? 1 : item.status,
    title: item?.title || item?.categoryName || "",
  }));
}

export function useGetNoticesList(props?:NoticeBarPropsType): NoticeBarType {
  const noticeBarState: UnwrapNestedRefs<NoticeBarStateType> = reactive({
    noticeDataVisible: false,
    viewNoticeIdx: 0,
    findNoticeDatas: [],
  });
  async function getListAction() {
    if (!getSassmallToken()) {
      noticeBarState.findNoticeDatas = [];
      noticeBarState.viewNoticeIdx = 0;
      noticeBarState.noticeDataVisible = false;
      return;
    }

    try {
      const response = await pageSassmallShopAnnouncements({
        pageNo: 1,
        pageSize: props?.pageSize || 99,
      });
      if (!isSassmallResponseSuccess(response)) {
        throw new Error(response?.message || response?.msg || "商城公告加载失败");
      }

      const findItems: any[] = localizeNotices(
        filterActiveNotices(normalizeAnnouncementList(response?.data))
      );
      noticeBarState.findNoticeDatas = findItems;
      noticeBarState.viewNoticeIdx = 0;
      noticeBarState.noticeDataVisible = false;

      if (
        findItems.length
        && props?.autoPopup !== false
        && !window.sessionStorage.getItem("isNoticeBarOpen")
        && !isNoticeHiddenByScope(props?.storageScope || "default")
      ) {
        window.sessionStorage.setItem("isNoticeBarOpen", "1");
        noticeBarState.noticeDataVisible = true;
      }
    }
    catch (error) {
      noticeBarState.findNoticeDatas = [];
      noticeBarState.viewNoticeIdx = 0;
      noticeBarState.noticeDataVisible = false;
      console.warn("sassmall announcement load failed", error);
    }
  }

  return {
    getListAction,
    noticeBarState,
  };
}
